import FingerprintJS from "@fingerprintjs/fingerprintjs";
import axios from "axios";
import { ICountry } from "../helpers/types";
import { COUNTRIES } from "../utls/CountryUtil";

class UtilService {
  public getPhoneCoutries = () => {
    return new Promise<ICountry[]>((resolve) => {
      resolve(COUNTRIES);
    });
    /* const url = `/countries/list`;
    return new Promise<ICountry[]>((resolve, reject) => {
      axios.get(url)
        .then((response) => {
          if (response?.data?.data) {
            resolve(response.data.data);
          } else {
            reject("Something went wrong.");
          }
        })
        .catch((error) => {
          if (error?.response?.data?.message)
            reject(error.response.data.message);
          else reject("Something went wrong.");
        });
    }); */
  };

  public fetchUserCountry = async () => {
    return new Promise<string>((resolve, reject) => {
      axios
        .get(`https://ipapi.co/country_name/`)
        .then((response) => {
          if (response?.data) {
            resolve(response.data);
          } else {
            resolve("France");
          }
        })
        .catch((error) => {
          console.log(`Getting error in fetching current country : ${error?.message}`);
          resolve("France");
        });
    });
  };

  public fetchClientDetails = async () => {
    try {
      // Fetch IP Address
      let IPAddress: string | null = null;
      try {
        const ipResponse = await axios.get("https://ipapi.co/json/");
        IPAddress = ipResponse?.data?.ip || null;
      } catch (ipError) {
        console.warn("Failed to fetch IP address:", ipError);
        IPAddress = null;
      }

      // Fetch Fingerprint
      const fp = await FingerprintJS.load();
      const fingerPrint = (await fp.get()).visitorId;

      // Get User-Agent
      const userAgent = navigator.userAgent;

      return {
        IPAddress,
        fingerPrint,
        userAgent,
      };
    } catch (error) {
      console.error("Error fetching client details :", error);
    }
  };

  // Cache for ad content to avoid redundant network calls per URL during a session
  private adContentCache: Map<string, string> = new Map();

  public getAdContent = async (s3Url: string) => {
    // Return cached value if present
    if (this.adContentCache.has(s3Url)) {
      return this.adContentCache.get(s3Url) as string;
    }
    try {
      // Using native fetch instead of axios to avoid triggering CORS preflight with default headers
      const response = await fetch(s3Url);
      if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);
      const content = await response.text();
      
      if (content) {
        this.adContentCache.set(s3Url, content);
      }
      return content;
    } catch (error) {
      console.error(`Error fetching ad content from ${s3Url}:`, error);
      return null;
    }
  };

  public getAdZoneId = async (s3Url: string) => {
    const data = await this.getAdContent(s3Url);
    if (!data) return null;
    const match = data.match(/data-zoneid="(\d+)"/);
    return match ? match[1] : null;
  };
}

export const utilService = new UtilService();
